import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import "./index.css";
import config from './app.config';
import App from "./App";

import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";

import { I18nextProvider } from 'react-i18next';
import i18n from './locate/i18n.jsx'

import "bootstrap/dist/css/bootstrap.min.css";
// eslint-disable-next-line
import $ from "jquery";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar, faBeer, faEnvelope, faLock, faExclamationTriangle, faMobileAlt, faCloud, faChartBar, faUserShield } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/js/bootstrap.bundle.min";

import ReactGA from 'react-ga4';
import store from "./store";
import { FeedsProvider } from "./feedstore.js";

// --- PCD Extensions: Google Analytics & Ads ---
const gaId = process.env.REACT_APP_GA_TRACKING_ID;
const adsId = process.env.REACT_APP_GADS_ID;
const extensionsEnabled = process.env.REACT_APP_ENABLE_PCD_EXTENSIONS === "true";

// Avoid collusion: only init if enabled and not already handled by a "Pro" host site or explicitly disabled
const shouldInit = extensionsEnabled && !window.PCD_PRO_ACTIVE && !window.PCD_DISABLE_EXTENSIONS;

if (shouldInit && (gaId || adsId)) {
  if (gaId) {
    ReactGA.initialize(gaId);
  }
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId || adsId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  if (gaId) window.gtag("config", gaId);
  if (adsId) window.gtag("config", adsId);
}

library.add(faStar, faBeer, faEnvelope, faLock, faExclamationTriangle, faMobileAlt, faCloud, faChartBar, faUserShield);

const oktaAuth = new OktaAuth({
  issuer: config.issuer,
  clientId: config.client_id,
  redirectUri: config.redirect_uri,
});

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <Router>
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <FeedsProvider>
            <App />
          </FeedsProvider>
        </Security>
      </Router>
    </Provider>
  </I18nextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
